var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowNextBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 10,
    viewBox: "0 0 6 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.25448 0.592102L6 5.0921L2.25448 9.5921H0L3.74552 5.0921L0 0.592102L2.25448 0.592102Z",
    fill: "#35C7FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowNextBlue);
export default __webpack_public_path__ + "static/media/arrow-next-blue.0ef781b82dcd2585932e6c4eadeaa5dd.svg";
export { ForwardRef as ReactComponent };